import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { supabase } from "../supabaseClient";
import toast, { Toaster } from "react-hot-toast";
import { Send, Loader2, CheckCircle2 } from "lucide-react";
import "../styles/ContactPage.css";
import TopBar from "../components/TopBar";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const ContactPage = () => {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { error } = await supabase.from("contact_inquiries").insert([{ 
        full_name: formData.name, email: formData.email, message: formData.message, status: 'New'
      }]);
      if (error) throw error;
      setSubmitted(true);
    } catch (err) {
      toast.error("Network Error: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-root">
      <Toaster position="top-right" />
      <TopBar />
      <Navbar />
      
      <main className="contact-split-layout">
        <section className="contact-info-panel">
          <div className="info-content">
            <span className="brand-tag">Secure & Trusted</span>
            <h1>The Architecture of <br/><span className="serif-text">Modern Risk.</span></h1>
            
            <div className="address-block">
              <h3>Headquarters</h3>
              <p>Rift Insurance Building,<br/> Kenyatta Avenue, Nakuru</p>
            </div>
          </div>
        </section>

        <section className="contact-form-panel">
          <div className="form-wrapper-modern">
            <AnimatePresence mode="wait">
              {!submitted ? (
                <motion.div 
                  key="form"
                  initial={{ opacity: 0, x: 20 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: -20 }}
                >
                  <header className="form-header">
                    <h2>Send an Inquiry</h2>
                    <p>Tell us about your requirements and we'll get back to you.</p>
                  </header>

                  <form className="luxury-form" onSubmit={handleSubmit}>
                    <div className="luxury-input-group">
                      <input type="text" required placeholder=" " value={formData.name}
                        onChange={(e) => setFormData({...formData, name: e.target.value})} />
                      <label>Legal Name</label>
                    </div>

                    <div className="luxury-input-group">
                      <input type="email" required placeholder=" " value={formData.email}
                        onChange={(e) => setFormData({...formData, email: e.target.value})} />
                      <label>Email Address</label>
                    </div>

                    <div className="luxury-input-group">
                      <textarea required placeholder=" " rows="4" value={formData.message}
                        onChange={(e) => setFormData({...formData, message: e.target.value})} />
                      <label>How can we assist you?</label>
                    </div>

                    <button className="luxury-submit" disabled={loading}>
                      <span>{loading ? "Sending..." : "Dispatch Inquiry"}</span>
                      {loading ? <Loader2 className="spin" /> : <Send size={18} />}
                    </button>
                  </form>
                </motion.div>
              ) : (
                <motion.div 
                  key="success"
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  className="success-container"
                >
                  <div className="success-icon-wrap">
                    <CheckCircle2 size={60} strokeWidth={1.5} />
                  </div>
                  <h2 className="success-title">Message Dispatched</h2>
                  <p className="success-text">
                    Thank you for reaching out. Your inquiry has been logged in our system. 
                    Our risk analysts will review your request and contact you within **24 hours**.
                  </p>

                  <button onClick={() => setSubmitted(false)} className="back-btn">
                    Return to Form
                  </button>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default ContactPage;